import { Dispatch } from "redux";
import { setBundleSelectedDataAction } from "../app/store/manhattan/bundleData/actions";
import { AppState } from "../app/store/rootReducers";
import { ISelectedProductAdditionalItem } from "../entities/manhattan/submit/types";
import { IProductPrepared } from "../entities/product/types";

export const addSelectedProductsToBundle = (preBasketProducts: IProductPrepared[], state: AppState, next: Dispatch) => {
  const bundleData = state.manhattan.bundleData;
  const { paymentType } = state.productData.productData;
  const calculatedPreBasketProducts: ISelectedProductAdditionalItem[] = [];
  for (const preBasketProduct of preBasketProducts) {
    calculatedPreBasketProducts.push({
      id: preBasketProduct.id,
      quantity: 1,
      colorId: preBasketProduct.productColorsImages.colors[0].id,
      purchaseType: paymentType
    });
  }

  bundleData.selectedProducts[0].additionalItems = calculatedPreBasketProducts;
  next(setBundleSelectedDataAction(bundleData.selectedProducts));
};
